import { Decimal, Money } from "@station/core";
import { z } from "zod";
/**
 * Motorun ortak tipleri. Hepsi SAF veridir: `Date` dışında çalışma zamanı bağımlılığı yoktur,
 * para hiçbir yerde `number` değildir (AGENTS.md §3.2).
 */
/** Satır türü — `docs/domain/pos-local-api.md` §3 `lines[].kind`. */
export const SALE_LINE_KINDS = ["FUEL", "ITEM", "WASH", "EV", "SERVICE"];
export const saleLineKindSchema = z.enum(SALE_LINE_KINDS);
/**
 * Birim fiyatın ÖLÇEĞİ. Protokol iki ölçek kullanır (pos-local-api §3 örneği + agent-protocol §2 notu):
 *  - `MAJOR` → ₺ cinsinden, en çok 4 ondalık ("63.3300" ₺/L). Akaryakıt satırı böyledir.
 *  - `MINOR` → kuruş tam sayı ("4500" = 45,00 ₺). Market / yıkama satırı böyledir.
 * Varsayılan `kind`'dan türetilir (`FUEL` → MAJOR, diğerleri → MINOR) ama satır bazında geçersiz kılınabilir.
 */
export const UNIT_PRICE_SCALES = ["MAJOR", "MINOR"];
export const unitPriceScaleSchema = z.enum(UNIT_PRICE_SCALES);
export function defaultUnitPriceScale(kind) {
    return kind === "FUEL" ? "MAJOR" : "MINOR";
}
/** Satır tutarı: `gross = ROUND_HALF_UP(quantity × unitPrice)`, sonuç her zaman KURUŞ. */
export function lineGross(unitPrice, quantity, scale) {
    const exact = Decimal.from(unitPrice).mul(quantity);
    return scale === "MAJOR" ? Money.fromDecimalMajor(exact) : Money.fromMinor(exact.round(0).toBigInt());
}
/**
 * Tahsilat türleri (sunucu `POS_TENDER_TYPES` ile AYNI adlar — ADR 0017 §28). Puan harcaması (`LOYALTY_POINTS`) ve üçüncü
 * taraf çeki (`COUPON`) TAHSİLATTIR; işletmenin kendi kuponu ise kampanya motorunda İNDİRİMDİR (`requiresCoupon`).
 * `VEHICLE_RECOGNITION` = TTS ile tanınan filo aracının cariye yazılan satışı (veresiye limitine ve filo kuralına tabidir).
 */
export const TENDER_TYPES = [
    "CASH",
    "CARD",
    "ON_ACCOUNT",
    "FLEET",
    "VEHICLE_RECOGNITION",
    "COUPON",
    "LOYALTY_POINTS",
];
export const tenderTypeSchema = z.enum(TENDER_TYPES);
export const TENDER_TYPE_LABELS = {
    CASH: "Nakit",
    CARD: "Kart",
    ON_ACCOUNT: "Veresiye",
    FLEET: "Filo",
    VEHICLE_RECOGNITION: "Taşıt tanıma (TTS)",
    COUPON: "Çek / kupon",
    LOYALTY_POINTS: "Puan",
};
/** Cariye işleyen (limit denetimi gereken) tahsilat türleri. */
export const CREDIT_TENDER_TYPES = ["ON_ACCOUNT", "FLEET", "VEHICLE_RECOGNITION"];
/** Filo kuralına tabi tahsilat türleri (ADR 0017 §14). */
export const FLEET_TENDER_TYPES = ["FLEET", "VEHICLE_RECOGNITION"];
//# sourceMappingURL=types.js.map